import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from 'app/app.config';
import { Course } from 'app/shared/models';
import { environment } from 'environments/environment';

@Injectable()
export class CourseService {
  private courses: Course[];
  private courseApiUrl = this.config.getConfig('apiUrl') + '/v1/Courses';
  private headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization-ApiKey': this.config.getConfig('apiKey')
  });

  constructor(private http: HttpClient, private config: AppConfig) {}

  public getCourse(id: string): Promise<Course> {
    return this.http
      .get<Course>(this.courseApiUrl + '/' + id, { headers: this.headers })
      .toPromise()
      .catch(error => Promise.reject(error.message || error));
  }

  public getCourses(): Promise<Course[]> {
    if (this.courses) {
      return Promise.resolve(this.courses);
    }
    const params = new HttpParams();
    if (environment.includeOngoing) {
      params.append('includeOngoing', 'true');
    }
    return this.http
      .get<Course[]>(this.courseApiUrl, { headers: this.headers, params })
      .toPromise()
      .then(response => {
        this.courses = response;
        return this.courses;
      })
      .catch(error => Promise.reject(error.message || error));
  }
}
